module.exports = __webpack_public_path__ + "img/news_devianne.3a2fc09c.jpg";